/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import { Wrap } from './styles';

import WMS from 'services/crud/WMS';
import { toUrlFormat } from 'services/utils/formaters';

import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { useState, useEffect, useMemo } from 'react';

  /**
   * Component para exibição da legenda dentro do PopOver
   */
  export const Legend = ({    
    layer,
    map,
    handleClosePopOver
  }) => {
     const [globalLegend, setGlobalLegend] = useState(null);
     const [legend, setLegend] = useState(globalLegend);
     const [loadingLegend, setLoadingLegend] = useState(false);    
     const legendGraphicParams = useMemo(
        () => ({
          service: 'WMS',
          request: 'GetLegendGraphic',
          version: '1.0.0',
          format: 'image/png',
          layer: layer.getLayerNameParam(),
          bbox: map.getBounds().toBBoxString(),
          srcwidth: map.getSize().x,
          srcheight: map.getSize().y,    
          width: 18, //Necessário para compatibilizar com camas providas pelo MapServer
          height: 18, //Necessário para compatibilizar com camas providas pelo MapServer
          srs: layer.properties?.SRS
                ? layer.properties?.SRS
                : 'EPSG:4326', //WGS 84, para manter a compatibilidade com o sistema de coordenadas do Mapa          
          /**
            * A ultima opção é a responsável por ocultar as legendas das areas
            * que não estão dentro da visualização do usuário.
            */
          legend_options: 'fontAntiAliasing:true;forceLabels:on;hideEmptyRules:true',
        }),
        [layer , map]
    );

    /**
     * Carregamento da legenda da camada
     */
    useEffect(() => {      
      const getLegend = () => {        
        setLoadingLegend(true);
        layer.getServiceLegend(legendGraphicParams)
          .then((base64image) => {
            setLegend(base64image);            
            setGlobalLegend(base64image);
          })
          .catch((error) => {
            setLegend(
              `${layer.getServiceLink()}?${toUrlFormat(legendGraphicParams)}`
            );
            setGlobalLegend(
              `${layer.getServiceLink()}?${toUrlFormat(legendGraphicParams)}`
            );
          })
          .finally(() => setLoadingLegend(false));
      };
    
      if (!layer.getService() || layer.getService() === 'WMS') { 
        map.on('moveend', getLegend);
        map.on('zoomend', getLegend);
        map.on('resize', getLegend);
        getLegend();
        return () => {
          map.off('moveend', getLegend);
          map.off('zoomend', getLegend);
          map.off('resize', getLegend);
        };
      }      
    }, [legendGraphicParams, layer, map]);

    return (              
      <Wrap>
        <div className="header">
          <h3>
            Legenda {
              // Exibe label da coluna selecionada na classificação
              ((layer.type === 'importada' || layer.type === 'criada') && layer.classColumn)
                ? '(' + layer.classColumn + ')'
                : ''
            }
          </h3>
          <IconButton
            size="small"
            className="btn-close"
            onClick={handleClosePopOver}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <hr />
        <div id="legend-container" className="content">
      {
        (layer.type === 'importada' || layer.type === 'criada') ? (
          layer.getStaticLegend(map.getBounds(), false, layer.layerStyle.fillColor, layer.layerStyle.fillOpacity, layer.layerStyle.opacity)
        ) : (
          loadingLegend ? (
            <div className="loader">
              <CircularProgress color="inherit" />
            </div>
          ) : (
            <img alt="Legenda" src={legend} />
          )
        )
      }
    </div>
      </Wrap>                       
    )
}